import { CollapseType } from '@meitu/saas-editor-ui/es/types';
import { getLocaleStore } from '@/i18n';
import { IEditorType } from '@/types';
import { isFromHuaweiCustom } from '@/utils/common';

export interface IMenuItem {
    name: string;
    iconName: string;
    activeIconName?: string;
    collapseType: CollapseType;
    trackId?: string;
    iconTip?: any; // TODO: 需要明确类型
    hidden?: boolean;
    className?: string;
}

export const getMenus = (editorType: IEditorType, isPPTMode: boolean, hiddenMenus: Array<CollapseType>) => {
    const { $t } = getLocaleStore();

    const LAYER: IMenuItem = {
        name: '图层',
        iconName: 'Layer',
        activeIconName: 'LayerFill',
        collapseType: CollapseType.LAYER_MENU,
    };

    // 添加
    const ADD: IMenuItem = {
        name: $t((v) => v.menu.add),
        iconName: 'Add',
        activeIconName: 'AddFill',
        collapseType: CollapseType.SHORTCUT_MENU,
        trackId: '28',
        className: 'shortcut-menu-item',
    };

    // 调整
    const ADJUST: IMenuItem = {
        name: $t((v) => v.menu.adjust),
        iconName: 'DoubleAdjust',
        activeIconName: 'DoubleAdjustBoldFill',
        collapseType: CollapseType.ADJUST_MENU,
    };

    // 调色
    const MOG: IMenuItem = {
        name: $t((v) => v.menu.mog),
        iconName: 'MagicWand',
        activeIconName: 'MagicWandBoldFill',
        collapseType: CollapseType.MOG_MENU,
    };

    // 文字
    const TEXT: IMenuItem = {
        name: $t((v) => v.menu.text),
        iconName: 'TextSquare',
        activeIconName: 'TextSquareBoldFill',
        collapseType: CollapseType.TEXT_MENU,
    };

    // 元素
    const ELEMENT: IMenuItem = {
        name: $t((v) => v.menu.element),
        iconName: 'Sticker',
        activeIconName: 'StickerFill',
        collapseType: CollapseType.ELEMENT_MENU,
    };

    // 画图
    const DRAW: IMenuItem = {
        name: $t((v) => v.menu.draw),
        iconName: 'BrushAndBoard',
        activeIconName: 'BrushAndBoardFill',
        collapseType: CollapseType.BRUSH_MENU,
    };

    const BACKGROUND: IMenuItem = {
        name: $t((v) => v.menu.bg),
        iconName: 'Background',
        activeIconName: 'BackgroundFill',
        collapseType: CollapseType.BACKGROUND_MENU,
        trackId: '17',
    };

    // 我的（华为PC预装定制版内嵌，需要隐藏）
    const MINE: IMenuItem = {
        name: $t((v) => v.menu.mine),
        iconName: 'UserCircle',
        activeIconName: 'UserCircleBoldFill',
        collapseType: CollapseType.MINE_MENU,
        trackId: '16',
        hidden: isFromHuaweiCustom(),
    };

    // 页面（非 PPT）
    const PAGE_NORMAL: IMenuItem = {
        name: $t((v) => v.menu.pages),
        iconName: 'AddArtboard',
        activeIconName: 'AddArtboardBoldFill',
        collapseType: CollapseType.NAVIGATOR_MENU,
        trackId: '19',
    };

    const PAGE_PPT: IMenuItem = {
        name: $t((v) => v.menu.pages),
        iconName: 'Ppt',
        activeIconName: 'PptBoldFill',
        collapseType: CollapseType.NAVIGATOR_MENU,
        trackId: '19',
    };

    // 更多
    const MORE: IMenuItem = {
        name: $t((v) => v.menu.more),
        iconName: 'Toolbox',
        activeIconName: 'ToolboxFill',
        collapseType: CollapseType.MORE_MENU,
        trackId: '30',
    };

    const filter = (menus: (IMenuItem | null)[]) => {
        return menus.filter((item) => !!item && !hiddenMenus.includes(item.collapseType)) as IMenuItem[];
    };

    if (isPPTMode) {
        const menus = [LAYER, PAGE_PPT, TEXT, ELEMENT, DRAW, BACKGROUND, MINE, MORE];
        return filter(menus);
    }

    if (editorType === IEditorType.imageEditor) {
        const menus = [LAYER, ADJUST, MOG, TEXT, MINE, MORE];
        return filter(menus);
    }

    const menus = [LAYER, ADD, TEXT, ELEMENT, DRAW, BACKGROUND, MINE, PAGE_NORMAL, MORE];
    return filter(menus);
};
